import axios from "axios"

// Facturas de Compras
export async function fetchPurchaseInvoices(query = '') {
    return await axios.get(
            `purchases/invoice?${query}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function getPurchaseInvoice(id) {
    return await axios.get(
            `purchases/invoice/${id}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function createPurchaseInvoice(data) {
    return await axios.post(
            `purchases/invoice`, data)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function updatePurchaseInvoice(id, data) {
    return await axios.patch(
            `purchases/invoice/${id}`, data)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function deletePurchaseInvoice(id) {
    return await axios.delete(
            `purchases/invoice/${id}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

// Listado simple de facturas
export async function fetchPurchaseInvoiceList(query = '') {
    return await axios.get(
            `purchases/invoice-list?${query}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

// Pagos de Facturas
export async function fetchPurchasePayments(query = '') {
    return await axios.get(
            `purchases/payment?${query}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function createPurchasePayment(data) {
    return await axios.post(
            `purchases/payment`, data)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function deletePurchasePayment(id) {
    return await axios.delete(
            `purchases/payment/${id}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

// Facturas por Orden de Compra
export async function fetchPurchaseInvoicesByPO(purchaseOrderId) {
    return await axios.get(
            `purchases/purchase-order/${purchaseOrderId}/invoices`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

// Exportar facturas a Excel
export async function exportPurchaseInvoicesToExcel(query = '') {
    return await axios.get(
            `purchases/invoice-export?${query}`, {
                responseType: 'blob'
            })
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
} 